export function trackWhatsAppClick(cta_location) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "whatsapp_click",
    cta_location,
    page_path: window.location.pathname,
  });
}
